export function ElitePlansAdviceCarouselSkeleton() {
  return (
    <section aria-busy='true' aria-label='Loading advice cards'>
      <div className='px-5 animate-pulse'>
        <div className='mx-auto h-3 w-32 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
        <div className='mx-auto mt-3 h-5 w-52 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
      </div>

      <div className='mt-6'>
        <ul className='flex list-none gap-3 overflow-hidden px-5 pb-1'>
          <ElitePlansAdviceCardSkeleton />
          <ElitePlansAdviceCardSkeleton />
          <ElitePlansAdviceCardSkeleton />
        </ul>
      </div>
    </section>
  )
}

export function ElitePlansAdviceCardSkeleton() {
  return (
    <li className='w-[min(280px,78vw)] shrink-0 animate-pulse'>
      <div className='h-[220px] rounded-2xl border border-[color:var(--ep-ink-muted)]/10 bg-white/80 p-4'>
        <div className='mb-4 flex items-start justify-between'>
          <div className='size-10 rounded-xl bg-[color:var(--ep-ink-muted)] opacity-20' />
          <div className='size-3 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
        </div>
        <div className='h-4 w-2/3 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
        <div className='mt-2 h-3 w-full rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
        <div className='mt-2 h-3 w-4/5 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
        <div className='mt-6 space-y-3'>
          <div className='h-3 w-24 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
          <div className='h-3 w-28 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
        </div>
      </div>
    </li>
  )
}
